import React, { useState, useEffect } from 'react'
import {
  Box,
  Tabs,
  Tab,
} from '@mui/material'
import {
  TrendingDown as DesviacionIcon,
  AttachMoney as FinancierosIcon,
} from '@mui/icons-material'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import { getRolUser } from '@auteco/services/motosSnopServices'
import DesviacionContainer from './DesviacionContainer'
import InputsFinancierosContainer from './InputsFinancierosContainer'

const DesviacionCombinadaContainer = () => {
  const [activeTab, setActiveTab] = useState(0)
  const [infoBars, setInfoBars] = useState({})

  const getInfoBars = async () => {
    const response = await getRolUser()
    if (response) {
      setInfoBars(response.iam.nombre)
    }
  }

  useEffect(() => {
    getInfoBars()
  }, [])

  const handleTabChange = (event, newValue) => setActiveTab(newValue)

  const TabPanel = ({ children, value, index, ...other }) => (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`desviacion-tabpanel-${index}`}
      aria-labelledby={`desviacion-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  )

  const a11yProps = (index) => ({
    id: `desviacion-tab-${index}`,
    'aria-controls': `desviacion-tabpanel-${index}`,
  })

  // Determinar qué tabs mostrar basado en el rol
  const availableTabs = []
  
  if (infoBars === 'Comprador') {
    availableTabs.push({
      index: 0,
      label: 'Desviación',
      icon: <DesviacionIcon />,
      component: <DesviacionContainer />
    })
  }
  
  availableTabs.push({
    index: infoBars === 'Comprador' ? 1 : 0,
    label: 'Inputs Financieros',
    icon: <FinancierosIcon />,
    component: <InputsFinancierosContainer />
  })

  return (
    <Box sx={{ padding: 3 }}>
      <CardTitle title="Desviación Combinada" />

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="Desviación Combinada tabs"
          sx={{
            '& .MuiTab-root': {
              textTransform: 'none',
              minWidth: 120,
              fontWeight: 600,
              color: '#666',
              '&.Mui-selected': {
                color: '#4c75aa',
              },
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#4c75aa',
              height: 3,
            },
          }}
        >
          {availableTabs.map((tab) => (
            <Tab
              key={tab.index}
              icon={tab.icon}
              iconPosition="start"
              label={tab.label}
              {...a11yProps(tab.index)}
              sx={{ 
                display: 'flex',
                flexDirection: 'row',
                gap: 1,
              }}
            />
          ))}
        </Tabs>
      </Box>

      {availableTabs.map((tab) => (
        <TabPanel key={tab.index} value={activeTab} index={tab.index}>
          {tab.component}
        </TabPanel>
      ))}
    </Box>
  )
}

export default DesviacionCombinadaContainer 